// ** React Imports
import {useContext, useEffect, useState} from 'react'

// ** Third Party Components
import ReactCountryFlag from 'react-country-flag'
import { UncontrolledDropdown, DropdownMenu, DropdownItem, DropdownToggle } from 'reactstrap'

// ** Internationalization Context
import { IntlContext } from '@src/utility/context/Internationalization'
import langConfig from "@configs/langConfig"
import {getCurrentLang} from "@hooks/useLng"

const IntlDropdown = () => {

  const { t } = langConfig
  const currentLang = getCurrentLang() || 'en'

  // ** Context
  const intlContext = useContext(IntlContext)

  // ** Vars
  const langObj = {
    en: t('keys.English') || 'English',
    ar: t('keys.Arabic')  || 'Arabic'
  }

  const localStoreLang = localStorage.getItem('lang')
  const [lang, setLang] = useState(localStoreLang || 'en')

    useEffect(_ => {
        setLang(localStoreLang)
      const body = document.getElementsByTagName('body')[0];
      const html = document.getElementsByTagName('html')[0];
      if (currentLang === 'en'){
        body.setAttribute('style', 'font-family: "Circular Std", sans-serif !important;')
        html.setAttribute('style', 'font-family: "Circular Std", sans-serif !important;')
        html.setAttribute('lang', 'en')
      }else if (currentLang === 'ar'){
        html.setAttribute('lang', 'ar')
      }
  }, [])

  // ** Function to switch Language
  const handleLangUpdate = (e, lang) => {
    e.preventDefault()
    intlContext.switchLanguage(lang)
    setLang(lang)
    localStorage.setItem('lang', lang)
    window.location.reload();
  }

  return (
    <UncontrolledDropdown href='/' tag='li' className='dropdown-language nav-item'>
      <DropdownToggle href='/' tag='a' className='nav-link' onClick={e => e.preventDefault()}>
        <ReactCountryFlag
          className='country-flag flag-icon'
          countryCode={lang === 'en' ? 'us' : 'sa'}
          svg
        />
        <span className='selected-language'>{langObj[lang]}</span>
      </DropdownToggle>
      <DropdownMenu className='mt-0' right>
        <DropdownItem href='/' tag='a' onClick={e => handleLangUpdate(e, 'en')}>
          <ReactCountryFlag className='country-flag' countryCode='us' svg />
          <span className='ml-1'>{langObj['en']}</span>
        </DropdownItem>
        <DropdownItem href='/' tag='a' onClick={e => handleLangUpdate(e, 'ar')}>
          <ReactCountryFlag className='country-flag' countryCode='sa' svg />
          <span className='ml-1'>{langObj['ar']}</span>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}

export default IntlDropdown
